import api from './api';

const state = {
	loading: false,
	status: null,
	version: null,
};

const getters = {};

const mutations = {
	setLoading(state, loading) {
		state.loading = loading;
	},
	setStatus(state, status) {
		state.status = status;
		if (status) {
			console.log(`API status: ${status.status}`);
		}
	},
	setVersion(state, version) {
		state.version = version;
		if (version) {
			console.log(`API version: ${version.version}`);
		}
	},
};

const actions = {
	async load({ state, dispatch, commit }) {
		commit('setLoading', true);

		try {
			// Load both status and version
			const [statusResult, versionResult] = await Promise.all([
				api.get(),
				api.getVersion()
			]);
			commit('setStatus', statusResult.data);
			commit('setVersion', versionResult.data);
		} catch (err) {
			console.log(`Failed to load status/version: ${err.message}`);
		}

		commit('setLoading', false);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
